import { NestedRoute, NotFound } from 'packages/route/components'

import { RouteComponent } from './types'

/**
 * RouteMenus
 *
 * @param RouteComponent - props
 * @returns RouteComponent
 */
export const RouteMenus: RouteComponent = ({ route }) => {
  const finalRoutes = route?.subRoutes

  if (!finalRoutes?.length) {
    return <NotFound />
  }

  const defaultRoute = finalRoutes[0]

  return (
    <NestedRoute
      routes={finalRoutes}
      redirect={{
        to: defaultRoute.path,
      }}
    />
  )
}
